<script lang="ts" setup>
import { reactive } from 'vue'
import { SLUG_CATEGORY_NEWS } from '~/resources/news'
import type { NewsData } from '~/composables/news/interface'
import { useNews } from '~/composables/news/use-news'
import { SLUG_NEWS } from '~/constants'
import Skeleton from '~/components/common/skeleton.vue'
import NewsItem from '~/components/common/news/news-item.vue'
import { useSwiper } from '~/composables/common/use-swiper'
const { fetchAllCategoryData } = useNews()

const dataNews = reactive<NewsData[]>([])
const limit: number = 11
const { modules, SLIDERS_PER_VIEW, SPACE_BETWEEN_SWIPER } = useSwiper()
useAsyncData('news', async () => {
  fetchAllCategoryData(dataNews, 0, limit, SLUG_CATEGORY_NEWS.SOI_KEO)
  return { loaded: true }
})
</script>
<template>
  <div class="home-news">
    <div class="home-news__header">
      <div class="base-title">
        <h2 class="base-title__text">TIN TỨC BÓNG ĐÁ</h2>
      </div>
      <div class="news-slider-header">
        <NuxtLink class="news-slider-header__link" :to="`/${SLUG_NEWS.PAGE}`">Xem tất cả</NuxtLink>
      </div>
    </div>
    <template v-if="!dataNews[0]?.data.length">
      <div class="no-data">
        <div class="no-data__image">
          <NuxtImg
            format="webp"
            src="/assets/images/icons/icon-nodata-sports.png"
            alt="Icon News"
            width="108"
            height="108"
            densities="1x"
            preload
          />
        </div>
        <div class="no-data__title">Tin tức đang được cập nhật</div>
      </div>
    </template>
    <template v-else>
      <Swiper
        v-if="dataNews[0]?.data"
        :modules="modules"
        :navigation="{
          nextEl: '.home-news-button-next',
          prevEl: '.home-news-button-prev'
        }"
        :slidesPerView="SLIDERS_PER_VIEW.LARGE"
        :spaceBetween="SPACE_BETWEEN_SWIPER.LARGE"
      >
        <SwiperSlide v-for="(item, index) in dataNews[0].data" :key="index">
          <NewsItem
            :item="item"
            :categoryName="dataNews[0]?.category.name"
            :categorySlug="SLUG_CATEGORY_NEWS.SOI_KEO"
            hasPadding
          />
        </SwiperSlide>
      </Swiper>
      <div v-else class="skeleton-groups">
        <Skeleton height="298px" />
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/home/news.scss';
</style>
